import { Component, Injector, Input, OnInit } from '@angular/core';
import { ENUM_NGAY_NGHI } from 'tnx-admin-service/holiday/models';
import { HolidayService } from 'tnx-admin-service/holiday/services';
import { ComponentContextService, DataFormBase, DateCompareValidator, DateTimeControlSchema, EventData, FormSchemaBase, IValidator, Operator, TextAreaControlSchema, TextControlSchema } from 'tnx-shared';

@Component({
    selector: 'holiday-form',
    templateUrl: './holiday-form.component.html',
    styleUrls: ['./holiday-form.component.scss'],
    providers: [ComponentContextService]
})
export class HolidayFormComponent extends DataFormBase implements OnInit {
    @Input() type: number;

    constructor(
        protected _injector: Injector,
        protected _hodidayService: HolidayService,
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setting.baseService = this._hodidayService;
        this.setting.schema = <FormSchemaBase[]>[
            new TextControlSchema({
                field: 'code',
                label: this._translateService.instant('Mã'),
                required: true,
                mdWidth: 12
            }),
            new TextControlSchema({
                field: 'name',
                label: this._translateService.instant('Tên'),
                mdWidth: 12
            }),
            new DateTimeControlSchema({
                field: 'startDate',
                label: this._translateService.instant('Ngày bắt đầu'),
                required: true,
                mdWidth: 12,
                validators: [new DateCompareValidator(Operator.lowerThanEqual, 'endDate')]
            }),
            new DateTimeControlSchema({
                field: 'endDate',
                label: this._translateService.instant('Ngày kết thúc'),
                required: true,
                mdWidth: 12
            }),
            new TextControlSchema({
                field: 'sort',
                label: this._translateService.instant('Thứ tự'),
                mdWidth: 12,
                dataFormat: 'number'
            }),
            new TextAreaControlSchema({
                field: 'description',
                label: this._translateService.instant('Ghi chú'),
                mdWidth: 12
            })
        ];
    }

    async onFormInitialized(constrols: EventData) {
        // tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
        let itemName = 'ngày nghỉ lễ';
        if (this.model.data.type == ENUM_NGAY_NGHI.NGAY_NGHI_LE)
            itemName = 'ngày nghỉ lễ';
        else if (this.model.data.type == ENUM_NGAY_NGHI.NGAY_LAM_BU)
            itemName = 'ngày làm bù';
        if (this.model.data.id) {
        }
        else {
            this.model.data.type = this.type;
        }
    }

    async modifyDetailData(data) {
        // xử lý dữ liệu lấy từ get detail về
    }

    async onAfterGetDetail() {
        // xử lý dữ liệu sau khi đã lấy từ api (sau cả event modifyDetailData) về và trước khi hiển thị ra view
    }

    onBeforeSave() {
        // trước khi lưu
    }
}

export class DateTimeEndDateValidator implements IValidator {
    validate(event: EventData): boolean {
        console.log(event);
        if (event.parentModel.startDate && event.parentModel.startDate > event.value) {
            return false;
        }
        return true;
    }

    getError() {
        return 'Ngày kết thúc không được nhỏ hơn ngày bắt đầu';
    }
}

export class DateTimeStartDateValidator implements IValidator {
    validate(event: EventData): boolean {
        console.log(event);
        if (event.parentModel.endDate && event.parentModel.endDate < event.value) {
            return false;
        }
        return true;
    }

    getError() {
        return 'Ngày bắt đầu không được lớn hơn ngày kết thúc';
    }
}
